<script>
export default {
  name: "contactUsSection",
  data() {
    return {
      activeNames: ["1"],
      openingHours: "Monday - Friday | 9am - 5pm",
      address: "55 George Street, Norwood SA 5067"
    };
  },
  methods: {
    handleChange(val) {
      console.log(val);
    }
  }
};
</script>

<template>
  <el-row
    style="padding: 50px 0 ; background-color: #fff; margin: 0">
    <el-col :span="24" style="background-color: #003333; color: #fff; border-radius: 10px 10px 0 0; height:50px;display: flex; flex-direction: column; justify-content: center;">
      <el-row >
        <el-col :span="3" style="display: flex; flex-direction: row; justify-content: flex-start; padding-left: 10px" >
          <span class="contact-us-title">Contact Us </span>
        </el-col>
        <el-col  :span="6" style="display: flex; flex-direction: row; justify-content: flex-start">
          <span class="contact-us-desc">{{openingHours}}</span>
        </el-col>
        <el-col :span="12" :offset="3" style="display: flex; flex-direction: row; justify-content: flex-end; padding-right: 10px">
          <span class="contact-us-desc">{{address}}</span>
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="24">
      <GmapMap
        :center="{ lat: -34.9217624, lng: 138.6339243 }"
        :options="{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: true,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: false
        }"
        :zoom="15"
        class="google-map-section"
        style="width: 100%; max-height: 500px"
      >
        <GmapMarker
          :icon="require('../../../static/img/location.png')"
          :position="{ lat: -34.85304, lng: 138.60848 }"
        />
      </GmapMap>
    </el-col>
  </el-row>
</template>

<style scoped>
.contact-us-title {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  //line-height: normal;
}
.contact-us-desc {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
}
.get-in-touch-para {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
}
.font-color {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
}
.btn-primary {
  color: #fff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  padding: 14px 60px;
  font: 600 20px DINosaur-a, sans-serif;
}
.btn-secondary {
  display: flex;
  height: 48px;
  padding: 14px 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 5px;
  border: 2px solid #fff;
  background: #fff;
  color: #003333;
}

.btn-underline {
  justify-content: center;
  border-radius: 0;
  border-bottom: 1px solid #fff;
  padding-bottom: 2px;
  color: #fff;
}
.google-map-section {
  aspect-ratio: 1.79;
  object-position: center;
  flex-grow: 1;
}

.el-collapse {
  border-top: none;
}
.el-collapse-item /deep/ .el-collapse-item__header {
  background-color: #fff;
  color: #003333;
}
.el-collapse-item /deep/ .el-collapse-item__wrap {
  background-color: #fff;
}
.el-collapse-item /deep/ .el-collapse-item__content {
  color: #003333;
}
.font-style-collapse {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.font-style-desc {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
}
</style>



// WEBPACK FOOTER //
// src/components/contact/contactUsSection.vue